//import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './styles/_base.scss';
import './styles/functions.scss'
import './styles/main.scss';

import React from 'react';
import { render } from 'react-dom';
import { HashRouter, Routes, Route } from 'react-router-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';

import reducer from './store/reducer';

import SplashScreen from './pages/SplashScreen';
import Featured from './pages/Featured';
import Layout from './pages/Layout';
import Error from './pages/Error';
import Account from './pages/Account';
import Playlist from './pages/Playlist';
import Notice from './pages/Notice';
import Policy from './pages/Policy';
import Offline from './pages/offline';
import Agreement from './pages/Agreement';
import bdReq from './network/bdReq';
import bdAuth from './network/bdAuth';
import Connect from './pages/Connect';

bdReq.setApiUrl('https://api.blackdove.io');
// bdReq.setApiUrl('http://192.168.0.13:3004');

bdAuth.setAppId("fdea8d89jufd89kfff");
bdAuth.setUserEndpoint('/me');

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(thunk)));
const persistor = persistStore(store);

render(
  (
    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
      <Layout>
        <HashRouter>
          <Routes>
            <Route exact path="/" element={<SplashScreen />} />
            <Route path="/pair" element={<Connect />} />
            <Route path="/error" element={<Error />} />
            <Route path="/account" element={<Account />} />
            <Route path="/featured" element={<Featured />} />
            <Route path="/playlist/:playlistId" element={<Playlist />} />
            <Route path="/notice/:id?" element={<Notice />} />
            <Route path="/agreement" element={<Agreement />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/offline" element={<Offline />} />
          </Routes>
        </HashRouter>
      </Layout>
      </PersistGate>
    </Provider>
  ), document.getElementById('app'));
